// 展开/收起按钮样式
export const toggleButtonStyle = {
    position: 'absolute',
    right: '-12px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '24px',
    height: '24px',
    backgroundColor: '#fff',
    border: '1px solid #EEEEF1',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 100,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
};

/**
 * 侧边栏样式
 * 定义了侧边栏的基本样式，包括滚动、位置、背景色等
 */
export const siderStyle = {
    position: 'fixed',
    top: 0,
    bottom: 0,
    scrollbarGutter: 'stable',
    backgroundColor: '#fff',
    left: 0,
    padding: '20px 20px 0',
    height: 'calc(100vh - 94px)',
    borderRight: '1px solid #EEEEF1',
    overflow: 'initial',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.08)',
    '&::WebkitScrollbar': {
        width: '0px',
    },
    borderRadius: ' 0 10px 10px 0 ',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
};
